import { InstagramAnalyticsStoryDetails } from '@anytag/graphql';
import { PostModal } from '../shared';

export interface StoryPostTemplateProps {
  className?: string;
  onCloseModal?: () => void;
  data?: InstagramAnalyticsStoryDetails;
}

export const StoryPostTemplate = ({ data, className, onCloseModal }: StoryPostTemplateProps) => {
  if (!data) {
    onCloseModal?.();

    return null;
  }

  return (
    <PostModal.DetailsTemplate
      className={className}
      data={{
        caption: data.content,
        postDate: data.postDate,
        socialMedia: 'INSTAGRAM',
        postUrl: data.postUrl || '',
        images: data.storyVideoUrl ? [data.storyVideoUrl] : data.postImageUrl ? [data.postImageUrl] : [],
        info: {
          avatar: data.avatarUrl,
          followers: data.followers,
          name: data.instagramAccountName
        },
        statistics: {
          comments: data.comments,
          reach: data.reach,
          impressions: data.impressions,
          exits: data.exits,
          tapsForward: data.tapsForward,
          swipeForward: data.swipeForward,
          tapsBack: data.tapsBack
        }
      }}
    />
  );
};
